import { Breadcrumb } from "@gull";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import overlayFactory from "react-bootstrap-table2-overlay";
import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import {
  bookingDetails,
  exportBookedFlight,
  getBookingHistory,
  offlineTicketHandler,
  printUploadedOriginalTicket,
  refundInvoiceHandler,
  sendTicketInEmail,
  ticketHandler,
  updateBillNo,
  updateIssueDateTime,
} from "app/services/AdminServices/bookingService";
import { refundAmount, totalAmountService } from "app/services/memberService";
import queryString from "app/services/queryStringService";
import config from "config.json";
import moment from "moment";
import Tooltip from "rc-tooltip";
import {
  Badge,
  Button,
  Col,
  Dropdown,
  DropdownButton,
  Image,
  Modal,
  Row,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import {
  FaArrowsAltH,
  FaFileInvoice,
  FaLongArrowAltRight,
  FaUserCheck,
} from "react-icons/fa";
import {
  MdOutlineAirplaneTicket,
  MdOutlineRefresh,
  MdSearch,
  MdSystemUpdateAlt,
  MdTransferWithinAStation,
} from "react-icons/md";
import Swal from "sweetalert2";
import PassengerModal from "./Components/Booking/PassengerModal"; //./PassengerModal.jsx";
import TicketModal from "./Components/Booking/TicketModal";

import { AiFillFileExcel } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Insurance from "./Components/Booking/Insurance";
import MemberAutoComplete from "./Components/MemberAutoComplete";
import PnrAlert from "./PNR/PnrAlert";
import { TbFileInvoice } from "react-icons/tb";
import UploadOriginalTicket from "./Components/UploadOriginalTicket";
import { NotificationManager } from "react-notifications";
import OperationalUserAutoComplete from "./Components/OperationalUserAutoComplete";
import { getSupplierForReport } from "app/services/ReportListService";
import CommonAutoComplete from "../SalesWishReport/Components/CommonAutoComplete";

function BookingHistory() {
  const { dateTimeFormat } = config;
  const [isShowGlobalFilter, setIsShowGlobalFilter] = useState(true);
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canView, canEdit, canDelete });
  const [uploadOriginalCopy, setUploadOriginalCopy] = useState({
    modalOpen: false,
    row: null,
  });
  const navigate = useNavigate();
  const [showPassenger, setShowPassenger] = useState(false);
  const [showJourney, setShowJourney] = useState(false);

  const [showTicketModal, setShowTicketModal] = useState(false);
  const [ticketData, setTicketData] = useState({});
  const [passengers, setPassengers] = useState([]);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [SearchBy, setSearchBy] = useState("Booking");
  const [totalBookingAmount, setTotalBookingAmount] = useState(null);
  const [agentValue, setAgentValue] = useState();
  const [operationalAgentValue, setOperationalAgentValue] = useState();
  const [toDate, setToDate] = useState("");
  const [pnr, setPnr] = useState("");
  const [gdsPNR, setGdsPNR] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedOperationalValue, setSelectedOperationalValue] =
    useState(null);
  const [show, setShow] = useState(false);
  const [bookingStatus, setBookingStatus] = useState("");
  const [depart, setDepart] = useState("");
  const [arrival, setArrival] = useState("");
  const [paxName, setPaxName] = useState("");
  const [gateway, setGateway] = useState(null);
  const modalClose = () => setShow(false);
  const [row, setRow] = useState(null);
  const [showOriginalTicketModal, setShowOriginalTicketModal] = useState(false);
  const [ticketUrl, setTicketUrl] = useState("");

  const dateFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return cell ? (
      <div>
        <div>{moment(cell).format("DD/MM/YYYY")}</div>
        <div>{moment(cell).format("HH:mm")}</div>
      </div>
    ) : (
      "-"
    );
  };

  async function sendTicketInEmailHandler(id) {
    const data = await sendTicketInEmail(id);
    if (data.status === "Success") {
      Swal.fire("Send!", data.message, "success");
    }
  }
  const updateBillNoHandler = async (row) => {
    // ❌ Do not open Swal if billNumber not present
    let id;
    let name;
    if (row?.billNumber) {
      const parts = row.billNumber.split(" by ");
      id = parts[0]?.trim() || "";
      name = parts[1]?.trim() || "";
    }

    Swal.fire({
      title: "Update Bill No",
      html: `
      ${
        row?.billNumber
          ? `<div style="margin-bottom:8px;font-size:13px;">
        <b>Old Bill Number:</b> ${id}
        ${name ? `<br/><b>Updated By:</b> ${name}` : ""}
      </div>`
          : ``
      }
      <input id="billNumber" class="swal2-input" placeholder="New Bill Number." autocomplete="off"
           style="flex: 1; padding: 8px 10px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;">
    `,
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),

      preConfirm: async () => {
        const billNo = document.getElementById("billNumber")?.value?.trim();

        if (!billNo) {
          Swal.showValidationMessage("Bill number is required");
          return false;
        }

        try {
          const req = {
            bookingDetailsId: row.id,
            billNo: billNo,
            corelationId: row.coRelationId,
          };

          const res = await updateBillNo(req);

          if (res.data.status == "Success") {
            Swal.fire("Update Successful", res.data.message, "success");
          } else {
            Swal.showValidationMessage(res.data.message || "Update failed");
            return false;
          }
        } catch (error) {
          Swal.showValidationMessage(error?.message || "Something went wrong");
          return false;
        } finally {
          loadBookingDetails();
        }
      },
    });
  };
  const updateIssueDate = async (row) => {
    // Convert existing modifiedDate to input format (YYYY-MM-DDTHH:mm)
    const formatDateForInput = (date) => {
      if (!date) return "";
      const d = new Date(date);

      const pad = (n) => n.toString().padStart(2, "0");

      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate(),
      )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const defaultDate = formatDateForInput(
      row?.modifiedDate ?? row.invoiceDate,
    );

    Swal.fire({
      title: "Update Issue Date & Time",
      html: `
      <input 
        id="issueDate" 
        type="datetime-local" 
        class="swal2-input"
        value="${defaultDate}"
      >
    `,
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),

      preConfirm: async () => {
        const issueDateValue = document.getElementById("issueDate")?.value;

        if (!issueDateValue) {
          Swal.showValidationMessage("Issue date & time is required");
          return false;
        }

        try {
          // const issueDateISO = new Date(issueDateValue).toISOString();
          // debugger;
          const req = {
            issueDate: issueDateValue,
            corelationId: row.coRelationId,
          };

          const res = await updateIssueDateTime(req);

          if (res.data.status === "Success") {
            Swal.fire("Update Successful", res.data.message, "success");
          } else {
            Swal.showValidationMessage(res.data.message || "Update failed");
            return false;
          }
        } catch (error) {
          Swal.showValidationMessage(error?.message || "Something went wrong");
          return false;
        } finally {
          loadBookingDetails();
        }
      },
    });
  };
  async function getJourneyDetails(e, value) {
    setPassengers(value);
    setShowJourney(true);
  }

  async function getTicketDetails(e, value) {
    const response = await bookingDetails(value.id);
    setTicketData(response.data);
    setShowTicketModal(true);
  }

  async function PrintWebTicket(row) {
    // ;
    const response =
      row.bookingMode == "offline" ||
      row.bookingMode == "Offline" ||
      row.bookingMode == "OFFLINE"
        ? await offlineTicketHandler(row.bookingId, true)
        : await ticketHandler(row.bookingId, true);

    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      var blob = new Blob([response.data], { type: "application/pdf" });
      var blobURL = URL.createObjectURL(blob);
      window.open(blobURL);
    }
  }
  const refundInvoicePrint = async (row) => {
    // ;
    const response = await refundInvoiceHandler(row.bookingId, true);

    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      var blob = new Blob([response.data], { type: "application/pdf" });
      var blobURL = URL.createObjectURL(blob);
      window.open(blobURL);
    }
  };

  const uploadedOriginalTicketPrint = async (row) => {
    const response = await printUploadedOriginalTicket(row.id);

    if (response?.status !== 200) {
      NotificationManager.error("File Not Found");
      return;
    }

    const url = window.URL.createObjectURL(response.data);

    setTicketUrl(url);
    setShowTicketModal(true);
  };
  const handleCloseOriginalTicket = () => {
    setShowOriginalTicketModal(false);

    // cleanup blob url
    if (ticketUrl) {
      URL.revokeObjectURL(ticketUrl);
    }

    setTicketUrl("");
  };

  function handlePassengerClose() {
    setShowPassenger(false);
  }
  function handleJourneyClose() {
    setShowJourney(false);
  }

  function handleClose() {
    setShowTicketModal(false);
  }
  const priceFormatter = (cell, row) => (
    <span className="text-center">₹ {parseFloat(cell ?? 0).toFixed(2)}</span>
  );

  const gatewayFormatter = (cell, row) => {
    return cell == "TRAVELPORT_GAL" ? "TRAVELPORT GAL" : cell;
  };

  const JourneyType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        {row.journeyType == 1 ? (
          <>
            <div style={{ marginBottom: 5 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg={row.isDomestic == true ? "info" : "danger"}>
                {row.isDomestic == true ? "Domestic" : "International"} Oneway
              </Badge>
            </h6>
          </>
        ) : row.journeyType == 2 ? (
          <>
            <div style={{ marginBottom: 5, borderRadius: 15 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="warning" style={{ color: "black" }}>
                Domestic Return
              </Badge>
            </h6>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 5 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="22"
                      width={"22"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="22"
                    width={"22"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="primary">International Return</Badge>
            </h6>
          </>
        )}
      </div>
    );
  };

  const flightFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        {row.journeyType == 1 ? (
          <Tooltip
            placement="top"
            overlay={
              <div style={{ maxWidth: 250 }}>
                {row.airportDeparture.cityName} <FaLongArrowAltRight />{" "}
                {row.airportDestination.cityName}
              </div>
            }
          >
            <span>
              {row.airportDeparture.cityCode} <FaLongArrowAltRight />{" "}
              {row.airportDestination.cityCode}
            </span>
          </Tooltip>
        ) : (
          <Tooltip
            placement="top"
            overlay={
              <div style={{ maxWidth: 250 }}>
                {row.airportDeparture.cityName} <FaArrowsAltH />{" "}
                {row.airportDestination.cityName}
              </div>
            }
          >
            <span>
              {row.airportDeparture.cityCode} <FaArrowsAltH />{" "}
              {row.airportDestination.cityCode}
            </span>
          </Tooltip>
        )}
      </>
    );
  };
  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          {row.currentStatus == "COMPLETED" || row.currentStatus == "REFUND" ? (
            ""
          ) : (
            <Dropdown.Item
              // href="#"
              className="text-primary"
              data-bs-toggle="modal"
              data-bs-target="#virtualbank"
              onClick={(e) => getJourneyDetails(e, row)}
            >
              <MdSystemUpdateAlt className="text-primary me-4"></MdSystemUpdateAlt>
              Update PNR
            </Dropdown.Item>
          )}
          {row.currentStatus === "COMPLETED" && (
            <Dropdown.Item
              className="text-primary"
              onClick={() =>
                navigate(`/admin/flight/edit-booking-details/${row.id}`)
              }
            >
              <FaUserCheck className="text-primary me-4" />
              Edit Booking Details
            </Dropdown.Item>
          )}
          <Dropdown.Item
            className="text-primary"
            onClick={() => navigate(`/admin/flight/booking-details/${row.id}`)}
          >
            <FaUserCheck className="text-primary me-4" />
            Booking Details
          </Dropdown.Item>
          {row.currentStatus === "PENDING" && (
            <Dropdown.Item
              // href="#"
              className="text-primary"
              data-bs-toggle="modal"
              data-bs-target="#virtualbank"
              onClick={() => {
                Swal.fire({
                  title: `Refund Process`,
                  html: `
                  <div> <p style="font-weight: bold; font-size: 20px;">${
                    row?.airportDeparture?.cityName
                  }
                  <span style="margin: 0 5px;">&rarr;</span>
                  ${row?.airportDestination?.cityName}</p></div>
                  <table class="table">
                  <tr>
                  <td><h5 style="font-size: 12px;">Merchant Details:</h5></td>
                  <td style="font-size: 12px;">
                  <div>${row?.masterMember?.company}</div>
                  <div>${row.masterMember.memberFullName}(${
                    row.user.normalizedUserName
                  })</div>
                 </td>
                </tr>
                  <tr>
                    <td><h5 style="font-size: 12px;">Co Relation Id:</h5></td>
                    <td style="font-size: 12px;">${row.coRelationId}</td>
                  </tr>
                 
 
                  <tr>
                    <td><h5 style="font-size: 12px;margin-top:25px">Refund Amount :</h5></td>
                    <td>
                    <input id="amt" value="${
                      row.netTotalFare == null ? "" : row.netTotalFare
                    }" placeholder="Refund Amount" class="swal2-input" type="number" style="width: 200px; font-size: smaller;">
                    </td>
                  </tr>
                </table>
                  
          `,

                  showCancelButton: true,
                  confirmButtonText: "Confirm",
                  showLoaderOnConfirm: true,
                  allowOutsideClick: false,
                  preConfirm: async () => {
                    // ;
                    const res = await refundAmount({
                      id: row.id,
                      refundAmount: Number(
                        document.getElementById("amt").value,
                      ),
                      corelationId: row?.coRelationId,
                    });
                    // console.log(res);
                    if (res.data.status == "Success") {
                      Swal.fire({
                        title: res.data.message,
                        icon: "success",
                      });
                      loadBookingDetails();

                      setTimeout(() => {
                        loadTotalAmount();
                      }, 100);
                    } else {
                      Swal.fire({
                        title: "Something went to be wrong",
                        icon: "error",
                      });
                    }
                  },
                });
              }}
            >
              <MdTransferWithinAStation className="text-primary me-4" />
              Refund Amount
            </Dropdown.Item>
          )}

          {(row.currentStatus === "COMPLETED" ||
            row.currentStatus === "HOLD" ||
            row.currentStatus === "ON_HOLD" ||
            row.currentStatus === "PARTIAL CANCELLED") && (
            <>
              <Dropdown.Item
                className="text-primary"
                onClick={(e) => {
                  PrintWebTicket(row);
                }}
              >
                <MdOutlineAirplaneTicket className="text-primary me-4"></MdOutlineAirplaneTicket>{" "}
                Ticket
              </Dropdown.Item>

              {/* <Dropdown.Item
                className="text-primary"
                onClick={(e) => sendTicketInEmailHandler(row.id)}
              >
                <MdMarkEmailRead
                  className="text-primary me-4"
                  size={15}
                ></MdMarkEmailRead>
                Send Mail
              </Dropdown.Item> */}
            </>
          )}
          {(row.currentStatus == "FULLY CANCELLED" ||
            row.currentStatus == "PARTIAL CANCELLED") && (
            <Dropdown.Item
              className="text-primary"
              onClick={(e) => {
                refundInvoicePrint(row);
              }}
            >
              <FaFileInvoice className="text-primary me-4"></FaFileInvoice>
              Refund Invoice
            </Dropdown.Item>
          )}
          <Dropdown.Item
            className="text-primary"
            onClick={() => updateBillNoHandler(row)}
          >
            <TbFileInvoice
              className="text-primary me-4"
              size={15}
            ></TbFileInvoice>
            Update Bill No
          </Dropdown.Item>
          <Dropdown.Item
            className="text-primary"
            onClick={() => updateIssueDate(row)}
          >
            <TbFileInvoice
              className="text-primary me-4"
              size={15}
            ></TbFileInvoice>
            Update Issue Date
          </Dropdown.Item>
          <Dropdown.Item
            className="text-primary"
            onClick={() =>
              setUploadOriginalCopy({
                modalOpen: true,
                row: row,
              })
            }
          >
            <TbFileInvoice
              className="text-primary me-4"
              size={15}
            ></TbFileInvoice>
            Upload Original Ticket
          </Dropdown.Item>
          {row.ticketFilePath != null && (
            <Dropdown.Item
              className="text-primary"
              onClick={(e) => {
                uploadedOriginalTicketPrint(row);
              }}
            >
              <TbFileInvoice
                className="text-primary me-4"
                size={15}
              ></TbFileInvoice>
              Print Original Ticket
            </Dropdown.Item>
          )}
        </DropdownButton>
      </>
    );
  };
  const CarrierChargesFormatter = (cell, row) => {
    return (
      <>
        {row.flightCommissionType == "Negative" ? (
          <span className="text-center" style={{ color: "red" }}>
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        ) : row.flightCommissionType == "Positive" ? (
          <span className="text-center" style={{ color: "green" }}>
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        ) : (
          <span className="text-center text-primary">
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        )}
      </>
    );
  };
  const yQYrFormatter = (cell, row) => (
    <span className="text-center">
      ₹ {parseFloat(row.yqFare ?? 0).toFixed(2)} / ₹{" "}
      {parseFloat(row.yrFare ?? 0).toFixed(2)}
    </span>
  );
  const tdsAmount = (cell, row) => {
    const oldTds = row?.tdsAmount ?? 0;
    const newTds = row?.carrierCommTDS;
    return (
      <>
        <span className="text-center" style={{ color: "red" }}>
          ₹ {parseFloat(oldTds ?? newTds).toFixed(2)}
        </span>
      </>
    );
  };
  const gstComm = (cell, row) => {
    return (
      <>
        <span className="text-center" style={{ color: "red" }}>
          ₹ {Math.abs(cell ?? 0).toFixed(2)}
        </span>
      </>
    );
  };
  const commissionWithGST = (cell, row) => {
    const gst = row?.carrierCommGst ?? 0;
    const comm = row?.totalCarrierServiceCharges ?? 0;
    return (
      <>
        <span className="text-center" style={{ color: "red" }}>
          ₹ {Math.abs(comm - gst).toFixed(2)}
        </span>
      </>
    );
  };

  const userType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        <Row>
          <Col
            style={{
              textTransform: "uppercase",
            }}
          >
            <div>{row?.masterMember?.company}</div>
            <div>{row.user.normalizedUserName}</div>
          </Col>
        </Row>
      </>
    );
  };
  const bookBy = (cell, row) => {
    const value = row?.bookedByUser || "";
    const parts = value.split("-");

    let role = "";
    let userId = "";
    let name = "";

    if (parts.length >= 4) {
      role = `${parts[0]} ${parts[1]}`; // Sub-Merchant
      userId = parts[2];
      name = parts.slice(3).join("-"); // handles extra hyphens
    } else if (parts.length === 3) {
      role = parts[0];
      userId = parts[1];
      name = parts[2];
    }

    return (
      <Row>
        {row?.bookedByUser ? (
          <Col
            style={{
              textTransform: "uppercase",
            }}
          >
            <div>
              {userId} ({role})
            </div>
            {/* <div>{userId}</div> */}
            <div>{name}</div>
          </Col>
        ) : (
          <Col>-</Col>
        )}
      </Row>
    );
  };

  const pnrFormatter = (cell, row) => {
    return (
      <>
        {row.currentStatus == "PENDING" || row.currentStatus == "REFUND" ? (
          ""
        ) : (
          <Tooltip placement="top" overlay={<div>{row.pnr}</div>}>
            <span>
              <Button variant="outline-primary" size="sm">
                Check PNR
              </Button>
            </span>
          </Tooltip>
        )}
      </>
    );
  };
  const gdsPnrFormatter = (cell, row) => {
    return (
      <>
        {row.currentStatus == "PENDING" || row.currentStatus == "REFUND" ? (
          ""
        ) : (
          <Tooltip placement="top" overlay={<div>{row.gdsPnr}</div>}>
            <span>
              <Button variant="outline-primary" size="sm">
                Check GDS PNR
              </Button>
            </span>
          </Tooltip>
        )}
      </>
    );
  };
  const billNumberFormat = (cell, row) => {
    if (!row?.billNumber) return "-";
    const parts = row.billNumber.split(" by ");
    const id = parts[0]?.trim() || "";
    const name = parts[1]?.trim() || "";
    return (
      <>
        <div>{id}</div>
        <div
          style={{
            textTransform: "uppercase",
          }}
        >
          {name}
        </div>
      </>
    );
  };
  const ModifyBy = (cell, row) => {
    const value = row?.modifiedByUser || "";
    const parts = value.split("-");

    let role = "";
    let userId = "";
    let name = "";

    if (parts.length >= 4) {
      role = `${parts[0]} ${parts[1]}`; // Sub-Merchant
      userId = parts[2];
      name = parts.slice(3).join("-"); // handles extra hyphens
    } else if (parts.length === 3) {
      role = parts[0];
      userId = parts[1];
      name = parts[2];
    }

    return (
      <>
        {row?.modifiedByUser || row.modifiedDate ? (
          <Row>
            <Col
              lg={12}
              style={{
                textTransform: "uppercase",
              }}
            >
              <div>
                {userId} ({role})
              </div>
              {/* <div>{userId}</div> */}
              <div>{name}</div>
            </Col>
            <Col lg={12}>{dateFormatter(row.modifiedDate, row)}</Col>
          </Row>
        ) : (
          <>-</>
        )}
      </>
    );
  };
  const issueDateFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return cell ? (
      <div>
        <div>{moment(cell).format("DD/MM/YYYY")}</div>
        <div>{moment(cell).format("HH:mm")}</div>
      </div>
    ) : (
      <div>
        <div>{moment(row.invoiceDate).format("DD/MM/YYYY")}</div>
        <div>{moment(row.invoiceDate).format("HH:mm")}</div>
      </div>
    );
  };
  const columns = [
    {
      dataField: "id",
      text: "Action",
      formatter: actionFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
    {
      dataField: "journeyType",
      text: "Airlines",
      formatter: JourneyType,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "invoiceDate",
      text: "Booking Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
    },
    {
      dataField: "modifiedDate",
      text: "Issue Date",
      formatter: issueDateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDeparture.cityCode",
      text: "From - To",
      formatter: flightFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "departureDate",
      text: "Journey Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },

    {
      dataField: "pnr",
      text: "PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: pnrFormatter,
    },
    {
      dataField: "gdsPnr",
      text: "GDS PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: gdsPnrFormatter,
    },
    {
      dataField: "currentStatus",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },

    {
      dataField: "user.normalizedUserName",
      text: "User",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: userType,
    },
    {
      dataField: "subMerchantName",
      text: "Book By",
      headerStyle: (colum, colIndex) => {
        return { width: "250px", textAlign: "center" };
      },
      formatter: bookBy,
    },
    {
      dataField: "modifiedByUser",
      text: "Modify By",
      formatter: ModifyBy,
      headerStyle: (colum, colIndex) => {
        return { width: "250px", textAlign: "center" };
      },
    },

    {
      dataField: "apiGateway",
      text: "Gateway",

      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
      formatter: gatewayFormatter,
    },
    {
      dataField: "bookingMode",
      text: "Booking Mode",

      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "publishTotalFare",
      text: "Booked Total Price",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "netTotalFare",
      text: "Booked Net Price",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },

    {
      dataField: "baseFare",
      text: "Base Price",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "taxFare",
      text: "Tax Price",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "yqFare",
      text: "YQ / YR",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: yQYrFormatter,
    },
    {
      dataField: "totalCarrierServiceCharges",
      text: "Commission without GST",
      headerStyle: (colum, colIndex) => {
        return { width: "180px", textAlign: "center" };
      },
      formatter: CarrierChargesFormatter,
    },
    {
      dataField: "carrierCommGst",
      text: "GST Commission",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: gstComm,
    },
    {
      dataField: "adminTotalGst",
      text: "Commission with GST",
      headerStyle: (colum, colIndex) => {
        return { width: "180px", textAlign: "center" };
      },
      formatter: commissionWithGST,
    },

    {
      dataField: "tdsAmount",
      text: "TDS Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: tdsAmount,
    },

    {
      dataField: "adminMarkupAmount",
      text: "Markup",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "refundStatus",
      text: "Refund Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "billNumber",
      text: "Bill Number",
      headerStyle: (colum, colIndex) => {
        return { width: "180px", textAlign: "center" };
      },
      formatter: billNumberFormat,
    },
  ];

  function rowStyle(row, rowIndex) {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    if (row.hasFrequentFlyer) {
      style.backgroundColor = "#f5ebff";
    }
    return style;
  }

  function NoDataIndication() {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  }
  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "fromDate":
        setFromDate(value);
        break;
      case "toDate":
        setToDate(value);
        break;
      case "pnr":
        setPnr(value);
        break;
      case "gdsPNR":
        setGdsPNR(value);
        break;
      case "SearchBy":
        setSearchBy(value);
        break;
      case "agentValue":
        setAgentValue(value);
        break;
      case "OperationUserName":
        setOperationalAgentValue(value);
        break;
      case "bookingStatus":
        setBookingStatus(value);
        break;
      case "depart":
        setDepart(value);
        break;
      case "arrival":
        setArrival(value);
        break;
      case "paxName":
        setPaxName(value);
        break;
      case "supplierWise":
        setGateway(value);
        break;

      default:
        break;
    }
  };
  async function loadBookingDetails() {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      fromDate,
      toDate,
      SearchBy,
      pnr,
      gdsPNR,
      agentValue,
      OperationUserName: operationalAgentValue,
      transactionStatus: bookingStatus,
      FromOrigin: depart,
      ToDestination: arrival,
      PassengerName: paxName,
      supplierWise: gateway?.label,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getBookingHistory(query);

    const getDistinctRecords = (data) => {
      const seenCoRelationIds = new Set();
      const result = [];

      for (let i = 0; i < data.length; i++) {
        const item = data[i];

        // If combo is false treat as separate record
        if (item.combo === false && item.combo !== null) {
          result.push({ ...item });
          continue;
        }

        if (!seenCoRelationIds.has(item.coRelationId)) {
          seenCoRelationIds.add(item.coRelationId);

          const filteredData = data.filter(
            (entry) => entry.coRelationId === item.coRelationId,
          );

          const lastOccurrence = {
            ...filteredData[filteredData.length - 1],
          };

          // Journey Type = 2 (Round Trip)
          if (lastOccurrence.journeyType == 2) {
            lastOccurrence.netTotalFare = filteredData.reduce(
              (sum, entry) => sum + (entry.netTotalFare || 0),
              0,
            );

            lastOccurrence.publishTotalFare = filteredData.reduce(
              (sum, entry) => sum + (entry.publishTotalFare || 0),
              0,
            );

            lastOccurrence.baseFare = filteredData.reduce(
              (sum, entry) => sum + (entry.baseFare || 0),
              0,
            );
            lastOccurrence.taxFare = filteredData.reduce(
              (sum, entry) => sum + (entry.taxFare || 0),
              0,
            );
            lastOccurrence.yqFare = filteredData.reduce(
              (sum, entry) => sum + (entry.yqFare || 0),
              0,
            );

            lastOccurrence.yFare = filteredData.reduce(
              (sum, entry) => sum + (entry.yFare || 0),
              0,
            );

            lastOccurrence.yrFare = filteredData.reduce(
              (sum, entry) => sum + (entry.yrFare || 0),
              0,
            );

            lastOccurrence.totalCarrierServiceCharges = filteredData.reduce(
              (sum, entry) => sum + (entry.totalCarrierServiceCharges || 0),
              0,
            );

            lastOccurrence.carrierCommGst = filteredData.reduce(
              (sum, entry) => sum + (entry.carrierCommGst || 0),
              0,
            );

            lastOccurrence.tdsAmount = filteredData.reduce(
              (sum, entry) => sum + (entry.tdsAmount || 0),
              0,
            );

            lastOccurrence.carrierCommTDS = filteredData.reduce(
              (sum, entry) => sum + (entry.carrierCommTDS || 0),
              0,
            );
          }

          // Journey Type 2 or 3
          if (lastOccurrence.journeyType == 3) {
            if (lastOccurrence.bookingMode == "Offline") {
              lastOccurrence.publishTotalFare = filteredData.reduce(
                (sum, entry) => sum + (entry.publishTotalFare || 0),
                0,
              );
              // lastOccurrence.netTotalFare = filteredData.reduce(
              //   (sum, entry) => sum + (entry.netTotalFare || 0),
              //   0,
              // );
            }
            lastOccurrence.baseFare = filteredData.reduce(
              (sum, entry) => sum + (entry.baseFare || 0),
              0,
            );
            lastOccurrence.taxFare = filteredData.reduce(
              (sum, entry) => sum + (entry.taxFare || 0),
              0,
            );
            lastOccurrence.yqFare = filteredData.reduce(
              (sum, entry) => sum + (entry.yqFare || 0),
              0,
            );

            lastOccurrence.yFare = filteredData.reduce(
              (sum, entry) => sum + (entry.yFare || 0),
              0,
            );

            lastOccurrence.yrFare = filteredData.reduce(
              (sum, entry) => sum + (entry.yrFare || 0),
              0,
            );
            lastOccurrence.totalCarrierServiceCharges = filteredData.reduce(
              (sum, entry) => sum + (entry.totalCarrierServiceCharges || 0),
              0,
            );

            lastOccurrence.carrierCommGst = filteredData.reduce(
              (sum, entry) => sum + (entry.carrierCommGst || 0),
              0,
            );

            lastOccurrence.tdsAmount = filteredData.reduce(
              (sum, entry) => sum + (entry.tdsAmount || 0),
              0,
            );

            lastOccurrence.carrierCommTDS = filteredData.reduce(
              (sum, entry) => sum + (entry.carrierCommTDS || 0),
              0,
            );
          }

          // Check Frequent Flyer
          const hasFrequentFlyer = filteredData.some((entry) =>
            entry.passengerList?.some(
              (passenger) =>
                passenger.frequentFlyerNo &&
                passenger.frequentFlyerNo.trim() !== "",
            ),
          );

          lastOccurrence.hasFrequentFlyer = hasFrequentFlyer;

          result.push(lastOccurrence);
        }
      }

      return result;
    };

    const distinctRecords = getDistinctRecords(response.data.data);

    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setLoading(false);
    setData(distinctRecords);
    setDataCount(paggingData.TotalCount);
  }

  const loadTotalAmount = async () => {
    const totalAmountReq = {
      operationalAgentId: operationalAgentValue,
      memId: agentValue,
      fromDate: fromDate,
      toDate: toDate,
      transactionType: SearchBy,
      transactionStatus: bookingStatus,
    };
    const totalAmountRes = await totalAmountService(totalAmountReq);
    // console.log(totalAmountRes);
    const totalAmount = totalAmountRes?.data?.totalDebitAmount;
    setTotalBookingAmount(totalAmount);
  };
  useEffect(() => {
    loadBookingDetails();

    setTimeout(() => {
      loadTotalAmount();
    }, 100);
  }, [
    page,
    sizePerPage,
    fromDate,
    toDate,
    pnr,
    gdsPNR,
    SearchBy,
    agentValue,
    bookingStatus,
    operationalAgentValue,
    // depart,
    // arrival,
    // paxName,
  ]); // Call loadBookingDetails whenever page or sizePerPage changes
  useEffect(() => {
    const isValid =
      (depart && depart.length >= 3) ||
      (arrival && arrival.length >= 3) ||
      (paxName && paxName.length >= 3);

    if (!isValid) return;

    const timer = setTimeout(() => {
      setPage(1); // reset pagination
      loadBookingDetails();

      setTimeout(() => {
        loadTotalAmount();
      }, 100);
    }, 500); // debounce

    return () => clearTimeout(timer);
  }, [depart, arrival, paxName]);

  function handleTableChange(type, { page, sizePerPage }) {
    setPage(page);
    setSizePerPage(sizePerPage);
  }

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);
    await loadBookingDetails();
    setTimeout(() => {
      loadTotalAmount();
    }, 100);
  };
  const refreshFilter = (e) => {
    setFromDate("");
    setToDate("");
    setPnr("");
    setGdsPNR("");
    setSearchBy("");
    setAgentValue();
    setOperationalAgentValue();
    setSelectedValue(null);
    setBookingStatus("");
    setDepart("");
    setArrival("");
    setPaxName("");
    setGateway(null);
  };

  
  const exportAllReq = async () => {
    const query = queryString.getQueryStringFromObj({
      fromDate,
      SearchBy,
      toDate,
      pnr,
      gdsPNR,
      agentValue,
      OperationUserName: operationalAgentValue,
      TransactionStatus: bookingStatus,
      FromOrigin: depart,
      ToDestination: arrival,
      PassengerName: paxName,
      supplierWise: gateway?.label || "",
      //supplierWise: gateway.label,
    });
    if (dataCount != 0) {
      setLoading(true);
    }

    const response = await exportBookedFlight(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_Flight_Booked_List.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };
  const handleExport = async () => {
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await exportAllReq();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const refreshGlobalFilter = async (e) => {
    setIsShowGlobalFilter(!isShowGlobalFilter);
  };

  return (
    <>
      <Helmet>
        <title>Booking History</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Booking History" }]}></Breadcrumb>
      <div className="bookingList-header" style={{ marginBottom: 20 }}>
        <Row>
          <Col lg={12} xs={12} sm={12} md={12}>
            {totalBookingAmount != null && (
              <div className="float-end me-4">
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                  }}
                >
                  <span className="text-primary">Total Booking Amount:</span> ₹{" "}
                  {Number(totalBookingAmount).toFixed(2)}
                </span>
              </div>
            )}{" "}
          </Col>
          <Row className="align-items-center mb-2">
            <Col className="col-md-12 d-flex justify-content-end mt-1">
              <Button
                variant="primary"
                className="mx-2"
                onClick={refreshGlobalFilter}
              >
                {isShowGlobalFilter ? (
                  <>
                    Filter <i className="i-Filter-2 mt-1" />
                  </>
                ) : (
                  <i className="i-Filter-2 mt-1" />
                )}
              </Button>

              <Button
                variant="primary"
                onClick={handleExport}
                disabled={!dataCount}
              >
                {isShowGlobalFilter ? (
                  <>
                    Export <AiFillFileExcel size={15} />
                  </>
                ) : (
                  <AiFillFileExcel size={15} />
                )}
              </Button>
            </Col>
          </Row>
          <div className={isShowGlobalFilter ? "collapse" : "show"}>
            <div className="card card-body rounded border mb-1">
              <Row>
                {/* Search By */}
                <Col md={2} col={12}>
                  <label>Search By</label>
                  <select
                    className="form-select"
                    name="SearchBy"
                    value={SearchBy}
                    onChange={handleSearchChanges}
                  >
                    <option value="Booking">Booking</option>
                    <option value="Travel">Travel</option>
                    <option value="Issue_Date">Issue Date</option>
                  </select>
                </Col>
                {/* Date From */}
                <Col md={2} col={12}>
                  <label>Date From</label>
                  <input
                    type="date"
                    className="form-control"
                    name="fromDate"
                    value={fromDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </Col>
                {/* Date To */}
                <Col md={2} col={12}>
                  <label>Date To</label>
                  <input
                    type="date"
                    className="form-control"
                    name="toDate"
                    value={toDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </Col>
                {/* PNR */}
                <Col md={2} col={12}>
                  <label>PNR</label>
                  <input
                    type="text"
                    className="form-control"
                    name="pnr"
                    placeholder="PNR"
                    value={pnr}
                    onChange={handleSearchChanges}
                  />
                </Col>
                {/* gdsPNR */}
                <Col md={2} col={12}>
                  <label>GDS PNR</label>
                  <input
                    type="text"
                    className="form-control"
                    name="gdsPNR"
                    placeholder="GDS PNR"
                    value={gdsPNR}
                    onChange={handleSearchChanges}
                  />
                </Col>
                {/* Agency */}
                <Col md={2} col={12}>
                  <label>Agency</label>
                  <MemberAutoComplete
                    selectedValue={selectedValue}
                    setSelectedValue={setSelectedValue}
                    name="agentValue"
                    setState={setAgentValue}
                  />
                </Col>
                {/* Booking Status */}
                <Col md={2} col={12}>
                  <label>Booking Status</label>
                  <select
                    className="form-select"
                    name="bookingStatus"
                    value={bookingStatus}
                    onChange={handleSearchChanges}
                  >
                    <option value="">Select option</option>
                    <option value="Completed">Completed</option>
                    <option value="Pending">Pending</option>
                    <option value="Refund">Refund</option>
                    <option value="Partial Cancelled">
                      Partial Cancellation
                    </option>
                    <option value="Fully Cancelled">Fully Cancellation</option>
                    <option value="Hold">Hold</option>
                    <option value="Unconfirmed">Unconfirmed</option>
                  </select>
                </Col>
                {/* Depart */}
                <Col md={2} col={12}>
                  <label>Origin (From)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="depart"
                    placeholder="Origin (From)"
                    value={depart}
                    onChange={handleSearchChanges}
                  />
                </Col>{" "}
                {/* Arrival */}
                <Col md={2} col={12}>
                  <label>Destination (To)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="arrival"
                    placeholder="Destination (To)"
                    value={arrival}
                    onChange={handleSearchChanges}
                  />
                </Col>{" "}
                {/* PNR */}
                <Col md={2} col={12}>
                  <label>Pax Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="paxName"
                    placeholder="Pax Name"
                    value={paxName}
                    onChange={handleSearchChanges}
                  />
                </Col>
                <Col md={2} col={12}>
                  <label>Operational User</label>
                  <OperationalUserAutoComplete
                    selectedValue={selectedOperationalValue}
                    setSelectedValue={setSelectedOperationalValue}
                    name="operationalAgentValue"
                    setState={setOperationalAgentValue}
                  />
                </Col>
                <Col md={2} col={12}>
                  <label>Gateway</label>
                  <CommonAutoComplete
                    name="supplierWise"
                    placeholder="Select Gateway"
                    api={getSupplierForReport}
                    value={gateway}
                    onChange={(selected) => {
                      setGateway(selected);
                    }}
                  />
                </Col>
                {/* Action Buttons */}
                <Col md={12} className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-outline-primary me-2"
                    onClick={handleSearch}
                  >
                    <MdSearch size={18} />
                  </button>

                  <button
                    className="btn btn-outline-primary"
                    onClick={refreshFilter}
                  >
                    <MdOutlineRefresh size={18} />
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Row>
      </div>
      <HandyScroll>
        <div
          className="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Action")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
      {showTicketModal && (
        <TicketModal
          show={showTicketModal}
          handleClose={handleClose}
          response={ticketData}
        />
      )}
      {showPassenger && (
        <PassengerModal
          show={showPassenger}
          handleClose={handlePassengerClose}
          response={passengers}
        />
      )}
      {showJourney && (
        <PnrAlert
          show={showJourney}
          handleClose={handleJourneyClose}
          response={passengers}
          loadBookingDetails={loadBookingDetails}
        />
      )}
      {show && (
        <Insurance show={show} modalClose={modalClose} response={passengers} />
      )}
      {uploadOriginalCopy.modalOpen && (
        <UploadOriginalTicket
          show={uploadOriginalCopy.modalOpen}
          row={uploadOriginalCopy.row}
          handleClose={() =>
            setUploadOriginalCopy({
              modalOpen: false,
              row: null,
            })
          }
          loadBookingDetails={loadBookingDetails}
        />
      )}
      {showTicketModal && (
        <Modal show={showTicketModal} onHide={handleClose} size="xl" centered>
          <Modal.Header closeButton>
            <Modal.Title>Original Ticket</Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ height: "80vh" }}>
            {ticketUrl && (
              <iframe
                src={ticketUrl}
                title="Ticket Preview"
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default BookingHistory;
